(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/react/components/more-charities-text.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/react/components/more-charities-text.js');

'use strict';

var _svs$lyckoplatsen$dat;
const relatedMoreInfo = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.relatedMoreInfo;
const {
  CmsTextFormatter
} = svs.lyckoplatsen.shared_utils.react.components;
const MoreCharitiesText = () => React.createElement("div", {
  className: "".concat(relatedMoreInfo === null || relatedMoreInfo === void 0 ? void 0 : relatedMoreInfo.color)
}, React.createElement("p", {
  className: "h2 margin-bottom-2 margin-top-2 align-left"
}, relatedMoreInfo === null || relatedMoreInfo === void 0 ? void 0 : relatedMoreInfo.textTitle), React.createElement("p", {
  className: "margin-bottom-1-half align-left"
}, React.createElement(CmsTextFormatter, {
  text: relatedMoreInfo === null || relatedMoreInfo === void 0 ? void 0 : relatedMoreInfo.textDescription
})));
setGlobal('svs.lyckoplatsen.components.shared_charity.react.components', {
  MoreCharitiesText
});

 })(window);